import React, { useState, useEffect } from 'react'
import { Button, Input, Select, Table, Checkbox, Popconfirm } from 'antd'
import 'aos/dist/aos.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Modal } from 'antd'
import { Option } from 'antd/es/mentions'
import DataTable from 'react-data-table-component' // DataTable library
import {
  GetOrderAllotmentAllAllocatedData,
  GetOrderAllotmentAllocatedBundles,
  GetOrderAllotmentDropdownList,
  GetOrderAllotmentList,
  GetOrderAllotmentListById,
  GetOrderAllotmentStock,
  UpdateActivationChangeStatus,
  UpdateOrderAllotmentAllocationStatus,
  UpdateOrderAllotmentProductionStatus,
  UpdateOrderAllotmentStatus,
} from '../../AllAPI/SalesAPI/SalesApi'
import { useNavigate, useParams } from 'react-router-dom'

const OrderAllotmentDetails = () =>  {
  const [selectedId, setSelectedId] = useState('')
 const navigate = useNavigate();
      const { orderId } = useParams();
      console.log("Order id",orderId);
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  }
  const [errors, setErrors] = useState({
    selectedId: '',
  })

  const goodTypesOptions = [
    { value: '1', label: 'F.T' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'Inch' },
  ]
  // const [allOrders, setAllOrders] = useState([]);
  // const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([])
  const [approvedItems, setApprovedItems] = useState(new Set())
  const [selectAll, setSelectAll] = useState(false)
  const [allOrders, setAllOrders] = useState([])
  const [allDropdownOrders, setAllDropdownOrders] = useState([])

  const [selectedOrder, setSelectedOrder] = useState(null)
  const [orderPass, setOrderPass] = useState(false)
  const [stockData, setStockData] = useState([])
  const [allocatedStock, setAllocatedStock] = useState([])
  const [allocated, setAllocated] = useState([])

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)
  const [isBulkSelecting, setIsBulkSelecting] = useState(false)
  const [selectedOrderItem, setSelectedOrderItem] = useState(null)
  const [selectedItemIds, setSelectedItemIds] = useState([])
    const [selectedItemIds1, setSelectedItemIds1] = useState([])

  const [selectedAllocationItem, setSelectedAllocationItem] = useState(null) // tracks the selected item for allocation
  const [allocatedItemsByName, setAllocatedItemsByName] = useState([]) // stores allocated data grouped by item name
  const [detailView, setDetailView] = useState(false)
  const [allocateBack, setAllocateBack] = useState(false) // tracks the selected item for allocation

  //======Search data from table===============
    const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
  
      const filtered = orderItems.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );

      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

//   // ==============Get  data================
//   let isOrderAllotmentFetched = false
//   useEffect(() => {
//     if (isOrderAllotmentFetched) return

//     fetchOrderAllotmentData()
//     console.log("All Orders",allOrders);
//     isOrderAllotmentFetched = true
//   }, [])

  useEffect(() => {
    const userData = sessionStorage.getItem("authToken");
    if (!userData) {
      navigate("/login");
    }
  }, []); 

  // useEffect(() => {
  //   const userData = sessionStorage.getItem("userData");
  //   if (!userData) {
  //     navigate("/login");
  //   }
  // }, []); 

//=========================== Getting AUTH TOken from session storage ============================================================================
  // useEffect(() => {
  //   const userData = sessionStorage.getItem("userData");
  //   if (!userData) {
  //     navigate("/login");
  //   }
  // }, []); 
useEffect(() => { 
  console.log("useEffect triggered");
  console.log("useEffect triggered, orderId:==>>", orderId); // Add this line

  fetchOrderAllotmentData();
  // fetchOrderData(orderId);   // Remove this, it will be called after allOrders is set
}, []); 

const fetchOrderAllotmentData = async () => {
  try {
    const response = await axios.get(GetOrderAllotmentList, commonHeaders);
    setAllOrders(response.data); // Update the allOrders state
    console.log("fetchOrderAllotmentData called ");
    console.log("Allotment data fetched successfully", response.data); // Log the response from the API
  } catch (error) {
    console.error('Error fetching Order Allotment data:', error);
    toast.error('Error fetching Order Allotment data');
  }
};

// Watch `allOrders` state and call `fetchOrderData` once it's updated
useEffect(() => {
  if (allOrders.length > 0) {
    console.log('All orders have been fetched:', allOrders);
    fetchOrderData(orderId); // Call fetchOrderData once allOrders has been set
  }
}, [allOrders]); 

  //     const orderItemColumns = [
  //       {
  //         title: "Sr.No.",
  //         dataIndex: "",
  //         key: "index",
  //         render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //       },
  //       {
  //         title: "Item Entry Date",
  //         dataIndex: "itemEntryDate",
  //         key: "itemEntryDate",
  //         render: (date) => {
  //           if (!date) return "-";
  //           const [year, month, day] = date.split("-");
  //           return `${day}/${month}/${year}`;
  //         },
  //       },
  //       {
  //         title: "Alloy",
  //         dataIndex: "alloyname",
  //         key: "alloyname",
  //       },
  //       {
  //         title: "Item Name",
  //         dataIndex: "dieName",
  //         key: "dieName",
  //       },
  //       {
  //         title: "Temper",
  //         dataIndex: "temperName",
  //         key: "tetemperName",
  //       },
  //       {
  //         title: "Weight",
  //         dataIndex: "weight",
  //         key: "weight",
  //       },
  //       {
  //         title: "Length",
  //         dataIndex: "length",
  //         key: "length",
  //       },
  //       {
  //         title: "Pcs",
  //         dataIndex: "pcs",
  //         key: "pcs",
  //       },
  //       {
  //         title: "Qty",
  //         dataIndex: "qty",
  //         key: "qty",
  //       },
  //       // {
  //       //   title: "Allocation Done",
  //       //   dataIndex: "allocationDone",
  //       //   key: "allocationDone",
  //       // },
  //       {
  //         title: "Send to Production",
  //         dataIndex: "sendToProduction",
  //         key: "sendToProduction",
  //       },
  //       {
  //         title: "Allocated Pcs",
  //         dataIndex: "allocatedPcs",
  //         key: "allocatedPcs",
  //       },
  //       {
  //         title: "Allocated Qty",
  //         dataIndex: "allocatedQty",
  //         key: "allocatedQty",
  //       },
  //       {
  //            title:" Prod. Pcs",
  //           dataIndex: "productionPcs",
  //           key: "productionPcs",},

  //           {
  //              title:"Prod. Qty",
  //             dataIndex: "productionQty",
  //             key: "productionQty",},

  //       {
  //         title: "Select",
  //         key: "select",
  //         render: (text, record) => (
  //           <Checkbox
  //             checked={selectedItemIds.includes(record.id)}
  //             onChange={(e) => {
  //               const checked = e.target.checked;
  //               setSelectedItemIds((prev) =>
  //                 checked
  //                   ? [...prev, record.id]
  //                   : prev.filter((id) => id !== record.id)
  //               );
  //             }}
  //           />
  //         ),
  //       },

  //       {
  //         title: "Actions",
  //         key: "actions",
  //         render: (text, record) => (
  //           <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
  //             <Button
  //               type="primary"
  //               className="UpdateBtn"
  //               style={{ fontSize: "12px" }}
  //               onClick={() => {
  //   setSelectedOrderItem(record);
  //   setSelectedAllocationItem(record); // ← Add this line
  // }}
  //             >
  //               Allocation
  //             </Button>
  //             <Button
  //               type="default"
  //               className="SubmitBtn"
  //               style={{ fontSize: "12px" }}
  //               onClick={() => {
  //                 handleProduction([record.id]);
  //                 setSelectedOrderItem(record);

  //               }}
  //             >
  //               Production
  //             </Button>
  //           </div>
  //         ),
  //       }

  //     ];
  const orderItemColumns = [
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Item Entry Date',
      dataIndex: 'itemEntryDate',
      key: 'itemEntryDate',
      render: (date) => {
        if (!date) return '-'
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    },
    {
      title: 'Item Name',
      dataIndex: 'dieName',
      key: 'dieName',
    },
    // {
    //   title: "Item Details",
    //   key: "alloyTemper",
    //   render: (_, record) => (
    //     <div>
    //       <div><strong>Alloy:</strong> {record.alloyname}</div>
    //       <div><strong>Temper:</strong> {record.temperName}</div>
    //       <div><strong>Length:</strong> {record.length}</div>
    //       <div><strong>Weight:</strong> {record.weight}</div>
    //       <div><strong>Pcs:</strong> {record.pcs}</div>
    //       <div><strong>Quantity:</strong> {record.qty}</div>
    //     </div>
    //   ),
    // },
    {
      title: 'Alloy',
      dataIndex: 'alloyname',
      key: 'alloyname',
    },
    {
      title: 'Temp',
      dataIndex: 'temperName',
      key: 'temperName',
    },
    {
      title: 'Wt/R',
      dataIndex: 'weight',
      key: 'weight',
    },
//     {
//       title: 'Length',
//       dataIndex: 'length',
//       key: 'length',
//     },
//     {
//   title: 'Unit',
//   dataIndex: 'unit',
//   key: 'unit',
//   render: (unit) => {
//     const unitOption = goodTypesOptions.find((opt) => opt.value === String(unit));
//     return unitOption ? unitOption.label : '';
//   },
// },
 {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },


    {
      title: 'Pcs',
      dataIndex: 'pcs',
      key: 'pcs',
    },
    {
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
    },

    {
      title: 'Prod. Status',
      dataIndex: 'sendToProduction',
      key: 'sendToProduction',
    },
    {
      title: 'Allo. Pcs',
      dataIndex: 'allocatedPcs',
      key: 'allocatedPcs',
    },
    {
      title: 'Allo. Qty',
      dataIndex: 'allocatedQty',
      key: 'allocatedQty',
    },
    {
      title: 'Prod. Pcs',
      dataIndex: 'productionPcs',
      key: 'productionPcs',
    },
    {
      title: 'Prod. Qty',
      dataIndex: 'productionQty',
      key: 'productionQty',
    },
    {
      title: 'Pend.  Pcs',
      dataIndex: 'pendingOrderPcs',
      key: 'pendingOrderPcs',
    },
    {
      title: 'Pend. Qty',
      dataIndex: 'pendingOrderQty',
      key: 'pendingOrderQty',
    },
    {
      title: 'Select',
      key: 'select',
      render: (text, record) => (
           <div
     style={{
          display: 'inline-block',
          padding: '4px',
          borderRadius: '4px',
          backgroundColor: '#023e7d', // Always highlight
        }}
      >
        <Checkbox
          checked={selectedItemIds.includes(record.id)}
          onChange={(e) => {
            const checked = e.target.checked
            setSelectedItemIds((prev) =>
              checked
                ? [...prev, record.id]
                : prev.filter((id) => id !== record.id),
            )
          }}
        /></div>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <Button
            type="primary"
            className="UpdateBtn"
            style={{ fontSize: '12px' }}
            onClick={() => {
              // setSelectedOrderItem(record);
              // setSelectedAllocationItem(record);
              // fetchAllocatedBumdles(record);
              fetchStock(record)
              setDetailView(false)
              // setAllocateBack(true);
            }}
          >
            Allocation
          </Button>
          {/* <Button
            type="default"
            className="SubmitBtn"
            style={{ fontSize: '12px' }}
            onClick={() => {
              showConfirmationModal([record.id])
              //handleProduction([record.id]);
              setSelectedOrderItem(record)
              setDetailView(false)
            }}
          >
            Production
          </Button> */}

          
<Button
  type="default"
  className="SubmitBtn"
  style={{ fontSize: '12px' }}
  onClick={() => {
    showConfirmationModal([record.id]); // pass single ID
    setSelectedOrderItem(record);
    setDetailView(false);
  }}
>
  Production
</Button>


  
        </div>
      ),
    },
  ]


const allocatedColumns = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => index + 1,
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => {
      const descA = a.dieName || '';
      const descB = b.dieName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
    sorter: (a, b) => {
      const descA = a.alloyName || '';
      const descB = b.alloyName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
    sorter: (a, b) => {
      const descA = a.temperName || '';
      const descB = b.temperName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Wt/R',
    dataIndex: 'weightRange',
    key: 'weightRange',
    sorter: (a, b) => {
      const descA = a.weightRange || '';
      const descB = b.weightRange || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => {
      const descA = a.length ?? 0;
      const descB = b.length ?? 0;
      return descA - descB;
    },
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
   //     {
// //       title: 'Length',
// //       dataIndex: 'length',
// //       key: 'length',
// //     },
// //     {
// //   title: 'Unit',
// //   dataIndex: 'unit',
// //   key: 'unit',
// //   render: (unit) => {
// //     const unitOption = goodTypesOptions.find((opt) => opt.value === String(unit));
// //     return unitOption ? unitOption.label : '';
// //   },
// // }
// // ,
  {
    title: 'Pcs',
    dataIndex: 'pcs',
    key: 'pcs',
    sorter: (a, b) => {
      const descA = a.pcs ?? 0;
      const descB = b.pcs ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Qty',
    dataIndex: 'netWeight',
    key: 'netWeight',
    sorter: (a, b) => {
      const descA = a.netWeight ?? 0;
      const descB = b.netWeight ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Packing Id',
    dataIndex: 'packingId',
    key: 'packingId',
    sorter: (a, b) => {
      const descA = a.packingId || '';
      const descB = b.packingId || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Dispatch/Jobwork Label',
    dataIndex: 'dispatchLabel',
    key: 'dispatchLabel',
    sorter: (a, b) => {
      const descA = a.dispatchLabel || '';
      const descB = b.dispatchLabel || '';
      return descA.localeCompare(descB);
    },
  },
];

  const stockColumns = [
    // {
    //   title: 'Stock ID',
    //   dataIndex: 'stockId',
    //   key: 'stockId',
    // },
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => index + 1,
    },
     {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => {
      const descA = a.dieName || '';
      const descB = b.dieName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
    sorter: (a, b) => {
      const descA = a.alloyName || '';
      const descB = b.alloyName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
    sorter: (a, b) => {
      const descA = a.temperName || '';
      const descB = b.temperName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Wt/R',
    dataIndex: 'weightRange',
    key: 'weightRange',
    sorter: (a, b) => {
      const descA = a.weightRange || '';
      const descB = b.weightRange || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => {
      const descA = a.length ?? 0;
      const descB = b.length ?? 0;
      return descA - descB;
    },
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
   //     {
// //       title: 'Length',
// //       dataIndex: 'length',
// //       key: 'length',
// //     },
// //     {
// //   title: 'Unit',
// //   dataIndex: 'unit',
// //   key: 'unit',
// //   render: (unit) => {
// //     const unitOption = goodTypesOptions.find((opt) => opt.value === String(unit));
// //     return unitOption ? unitOption.label : '';
// //   },
// // }
// // ,
  {
    title: 'Pcs',
    dataIndex: 'pcs',
    key: 'pcs',
    sorter: (a, b) => {
      const descA = a.pcs ?? 0;
      const descB = b.pcs ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Qty',
    dataIndex: 'netWeight',
    key: 'netWeight',
    sorter: (a, b) => {
      const descA = a.netWeight ?? 0;
      const descB = b.netWeight ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Packing Id',
    dataIndex: 'packingId',
    key: 'packingId',
    sorter: (a, b) => {
      const descA = a.packingId || '';
      const descB = b.packingId || '';
      return descA.localeCompare(descB);
    },
  },
    {
      title: '',
      key: 'selection',
      render: (text, record) => (
       <div
       style={{
          display: 'inline-block',
          padding: '4px',
          borderRadius: '4px',
          backgroundColor: '#023e7d', // Always highlight
        }}
      >
        <Checkbox
          checked={selectedItemIds1.includes(record.packingId)}
          onChange={(e) => {
            const checked = e.target.checked
            setSelectedItemIds1((prev) =>
              checked
                ? [...prev, record.packingId]
                : prev.filter((id) => id !== record.packingId),
            )
          }}
   
        /></div>
      ),
      
    },
  ]

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023e7d',
            color: '#fff',
            padding: '10px',
            fontSize: '14px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize: '14px',
          }}
        >
          {children}
        </td>
      ),
    },
  }
  const components1 = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#2E2E2E',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize: '15px',
          }}
        >
          {children}
        </td>
      ),
    },
  }
  const handleProduction = async (orderNumberIds) => {
    try {
      const response = await axios.put(
        `${UpdateOrderAllotmentProductionStatus}?orderNumberIds=${orderNumberIds}&status=1`,
        {},
        commonHeaders,
      )
      console.log('Response', response)

      if (response.data === 'UPDATED') {
         fetchOrderData(orderId)
        fetchOrderAllotmentData()
        toast.success('Sent to Production Successfully')
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Already Sent to Production !')
      }
    } catch (error) {
      console.error('Production error:', error)
      toast.error('Failed to send to production.')
    }
  }
   const handleStatusChange = async (orderNumberId, targetStatus) => {
  try {
    const response = await axios.put(
      `${UpdateActivationChangeStatus}?orderNumberId=${orderNumberId}&status=${targetStatus}`,
      {},
      commonHeaders
    );

    console.log('Response:', response.data);

    if (response.data === 'ORDER_MARKED_ACTIVE') {
      toast.success('Order marked as Active');
    } else if (response.data === 'ORDER_MARKED_INACTIVE') {
      toast.success('Order marked as Inactive');
    } 

    // Refresh data after update
    fetchOrderData(orderId);
    fetchOrderAllotmentData();
  } catch (error) {
    console.error('Production error:', error);
    toast.error('Failed to update order status.');
  }
};

  //      const handleCheckboxChange = (packingId) => {
  //   let updatedSelectedRowKeys;
  //   if (selectedRowKeys.includes(packingId)) {
  //     updatedSelectedRowKeys = selectedRowKeys.filter((id) => id !== packingId);
  //   } else {
  //     updatedSelectedRowKeys = [...selectedRowKeys, packingId];
  //   }
  //   setSelectedRowKeys(updatedSelectedRowKeys);
  // };
  const handleAllocation = async (orderNumberIds) => {
    try {
      const response = await axios.put(
        UpdateOrderAllotmentAllocationStatus,
        orderNumberIds,
        commonHeaders,
      )
      console.log('Response', response)

      if (response.data === 'UPDATED') {
         fetchOrderData(orderId)
        fetchOrderAllotmentData()
        toast.success('Allocated Successfully')
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Already Allocated !')
      }
    } catch (error) {
      console.error('Production error:', error)
      toast.error('Failed to send to production.')
    }
  }

 const [isModalVisible, setIsModalVisible] = useState(false);
const [pendingProductionIds, setPendingProductionIds] = useState([]);

const showConfirmationModal = (itemIds) => {
  setPendingProductionIds(itemIds);
  setIsModalVisible(true);
};


  const  fetchOrderData = async (orderId) => {
      console.log("fetchOrderData called ");
    const order = allOrders.find(o => o.id === parseInt(orderId)); 
  if (order) {
    setSelectedOrder(order);
    console.log("Selected Order", order);  // Log the selected order
  } else {
    console.log("Order not found in allOrders");
  }

    // console.log("selected order",selectedOrder);
    // let isValid = true
    // const errorObj = {}

    // // Validation: Ensure orderId is present and valid
    // if (!selectedId || (typeof selectedId === 'string' && !selectedId.trim())) {
    //   isValid = false
    //   errorObj.orderId = 'Order ID is required *'
    // }

    // setErrors(errorObj) // Set error messages
    // if (!isValid) return

    try {
      // API Call: Fetch order details using selected ID
      const response = await axios.get(
        `${GetOrderAllotmentListById}?orderNumberId=${orderId}`,
        commonHeaders,
      )

      const orderDetails = response.data

      if (!orderDetails) {
        toast.error('Failed to fetch order details.')
        return
      }

      console.log('Order details fetched successfully:', orderDetails)

      // You can now process or submit the orderDetails further
          if (Array.isArray(orderDetails) && orderDetails.length > 0) {
        setOrderItems(orderDetails)
        setFilteredData(orderDetails)
        setTotalEntries(orderDetails.length)
        console.log('Order submitted successfully!')

            //  const order = allOrders.find(o => o.id === parseInt(orderId)); 
            // setSelectedOrder(order); 
            // console.log("Selected Order",selectedOrder);//something is wrong

      }  // You can now process or submit the orderDetails further
       else {
        toast.warn('No items found for the selected order.')
        //setOrderItems([]) // Clear order items
       // setFilteredData([]) // Clear filtered data (this will reset the table display)
       // setTotalEntries(0) // Reset total entries count
      }
    } catch (error) {
      console.error('Error during order submission:', error)
      toast.error('An error occurred while processing the order.')
    }
  }
  const fetchAllocatedBumdles = async () => {

    try {
     
      const response = await axios.get(
       ` ${GetOrderAllotmentAllAllocatedData}?customerId=${selectedOrder.customerId}`,
        commonHeaders,
      )

      const orderDetails = response.data

      if (!orderDetails) {
        toast.error('Failed to allocated Bundle Details.')
        return
      }

      console.log('Order details fetched successfully:', orderDetails)

      // You can now process or submit the orderDetails further
      if (Array.isArray(orderDetails) && orderDetails.length > 0) {
        setAllocated(orderDetails)
        setDetailView(true)
        // setSelectedAllocationItem(record);
        // setFilteredData(orderDetails);
        // setTotalEntries(orderDetails.length);
        console.log('Order submitted successfully!')
      } else {
        toast.warn('No stock Allocated for the selected item.')
        setAllocated([]) // Clear order items
        // setFilteredData([]);  // Clear filtered data (this will reset the table display)
        // setTotalEntries(0);  // Reset total entries count
      }
    } catch (error) {
      console.error('Error during order submission:', error)
      toast.error('An error occurred while processing .')
    }
  }
   useEffect(() => {
      if (selectedOrder) {
        console.log("Selected Order Updated:", selectedOrder);
       
      }
    }, [selectedOrder]);
  const fetchStock = async (record) => {
    try {
      const { dieNameId } = record

      // First: Fetch Stock Data
      const stockRes = await axios.get(
        `${GetOrderAllotmentStock}?dieNameId=${dieNameId}&alloyId=${record.alloyId}&temperId=${record.temperId}`,
        commonHeaders,
      )

      const stockData = stockRes.data || []

      if (stockData.length > 0) {
        setStockData(stockData)
        setSelectedOrderItem(record)
        setSelectedAllocationItem(record)
        setAllocateBack(true)
        setDetailView(false)

        // Now fetch allocated data only if stock exists
        const allocatedRes = await axios.get(
          `${GetOrderAllotmentAllocatedBundles}?dieNameId=${dieNameId}&customerId=${selectedOrder.customerId}&alloyId=${record.alloyId}&temperId=${record.temperId}`,
          commonHeaders,
        )

        const allocatedData = allocatedRes.data || []
        setAllocatedStock(allocatedData)

        if (allocatedData.length === 0) {
          toast.warn('No stock allocated for the selected item.')
        }
      } else {
        toast.warn('No stock available for the selected item.')
        setStockData([])
        setDetailView(false)
      }
    } catch (error) {
      console.error('Error during stock fetch:', error)
      toast.error('An error occurred while processing.')
    }
  }
// //========================= To group on the basis of die name  ======================================================
  const groupedDataByDieName = allocated.reduce((acc, item) => {
    const key = item.dieName?.trim() // normalize key
    if (!acc[key]) acc[key] = []
    acc[key].push(item)
    return acc
  }, {})
// const groupedDataByDieName = allocated.reduce((acc, item) => {
//   const dieName = item.dieName?.trim() || '';
//   const alloy = item.alloyName?.trim() || '';
//   const temper = item.temperName?.trim() || '';
  
//   const key = `${dieName}|${alloy}|${temper}`; // Composite key

//   if (!acc[key]) acc[key] = [];
//   acc[key].push(item);
//   return acc;
// }, {});

//=================================================== To change color black or white ===========================================
// Function to calculate luminance of a color
const calculateLuminance = (color) => {
  // Remove the '#' from the hex code
  color = color.slice(1);

  // Convert hex to RGB
  let r = parseInt(color.substr(0, 2), 16) / 255;
  let g = parseInt(color.substr(2, 2), 16) / 255;
  let b = parseInt(color.substr(4, 2), 16) / 255;

  // Apply the luminance formula
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance;
};

// Function to determine text color (black or white)
const getTextColor = (bgColor) => {
  const luminance = calculateLuminance(bgColor);
  return luminance > 0.5 ? '#000' : '#FFF';  // If luminance is high, use black text, else white
};
//=============================================================================================================================================





  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
      <div
        className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff', minHeight: '800px' }}
      >
        <div className="col-12">
          <div className="container-fluid px-md-5 mt-3 p-2">
         

       
                {/* Order Header Details */}
 
  {!allocateBack &&(<div className="shadow border p-4 mb-4" style={{ backgroundColor: '#f8f9fa', fontSize: '17px' }}>
  <div className="order-summary my-3 px-2">
    {/* <h6 className="mb-3" style={{fontSize: "21px",fontWeight:"bold"}}>Order Details:</h6> */}
    <h4  className="mb-3">  <span style={{ minWidth: '130px', marginRight: '10px' }}>Customer Name:</span>
            <strong>{selectedOrder?selectedOrder.customerName:""}</strong></h4>
    <div className="container-fluid">
      <div className="row">

        {/* Column 1 */}
        <div className="col-md-4">
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Order Number:</span>
            <strong>{selectedOrder ?selectedOrder.orderNumber:""}</strong>
          </div>
          {/*   <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Order Entry Date:</span>
            <strong>{selectedOrder ?selectedOrder.entryDate:""}</strong>
          </div>*/}
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>PO Date:</span>
            <strong>{selectedOrder ?selectedOrder.poDate:""}</strong>
          </div>
          {/* <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Customer Instruction:</span>
            <strong>{selectedOrder ?selectedOrder.customerInstruction || '-':""}</strong>
          </div> */}
            <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Order Status:</span>
        <Button
    className="SubmitBtn"
    style={{
      backgroundColor: selectedOrder?.isActive ? '#28a745' : '#dc3545',
      borderColor: selectedOrder?.isActive ? '#28a745' : '#dc3545',
      color: '#fff',
    }}
    onClick={() =>
      handleStatusChange(
        selectedOrder?.id,
        selectedOrder?.isActive ? 0 : 1
      )
    }
  >
    {selectedOrder?.isActive ? 'Active' : 'Inactive'}
  </Button>
          </div>
        </div>

        {/* Column 2 */}
        <div className="col-md-4">
          {/* <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Customer Name:</span>
            <strong>{selectedOrder?selectedOrder.customerName:""}</strong>
          </div> */}

          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Pending Qty:</span>
            <strong>{selectedOrder?.pendingQty??"N/A"} Kgs</strong>
          </div>
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Total Qty:</span>
            <strong>{selectedOrder?.totalQty??"NA"} Kgs</strong>
          </div>
            <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Customer Instruction:</span>
            <strong>{selectedOrder ?selectedOrder.customerInstruction || '-':""}</strong>
          </div>
        </div>

        {/* Column 3 */}
        <div className="col-md-4">
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Ready Qty:</span>
            <strong>{selectedOrder?.readyQty??"N/A"} Kgs</strong>
          </div>
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Dispatch:</span>
            <strong>{selectedOrder?.dispatchQty ?? "N/A"} Kgs</strong>
          </div>
          <div className="d-flex mb-2 align-items-center">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Packing Remark:</span>
            <div
              style={{
                display: 'inline-block',
                backgroundColor:selectedOrder ?selectedOrder.colorHash:"",
                padding: '5px 10px',
                borderRadius: '4px',
                color: getTextColor(selectedOrder ?selectedOrder.colorHash:""),
              }}
            >
              {selectedOrder ?selectedOrder.orderNumber:""} ({selectedOrder ?selectedOrder.stickerCode:""})
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>)}




                {/* <div className="mt-4">
  <div className="row">
    {/* Conditionally render single or two-column layout 
    <div className={selectedAllocationItem ? "col-md-6" : "col-md-12"}>
    {/* <div className= "col-md-6"> 

      <h6>Order Items</h6>
      <Table
        dataSource={orderItems}
        columns={orderItemColumns}
        pagination={false}
        bordered
        rowKey={(record) => record.id}
        components={components}
        scroll={{ x: true }}
      />
    </div>

    {/* Conditionally render Available Stock table 
    {selectedAllocationItem && (
      <div className="col-md-6">
        <h6>Available Stock for: {selectedAllocationItem.dieName}</h6>
        <Table
  dataSource={stockData.filter(
    (stock) => stock.dieName === selectedAllocationItem?.dieName
  )}
  columns={stockColumns}
  pagination={false}
  bordered
  rowKey={(record) => record.stockId}
  components={components}
  scroll={{ x: true }}
/>

      </div>
    )}
  </div>
 {/* Send to Production Button 
 {selectedItemIds.length > 1 && (
    <div className="text-center px-md-5 mb-3">
      <Button
        type="primary"
        onClick={() => handleProduction(selectedItemIds)}
        style={{ marginTop: "10px" }}
      >
        Send to Production
      </Button>
    </div>
  )}
  */}

                {/* <div className="mt-4">
  <div className="row">
    {!detailView &&!selectedAllocationItem ? (
      // ===== Show Order Items Table =====
      <div className="col-md-12">
        <h6>Order Items</h6>
        <Table
          dataSource={orderItems}
          columns={orderItemColumns}
          pagination={false}
          bordered
          rowKey={(record) => record.id}
          components={components}
          scroll={{ x: true }}
        />
      </div>
    ) : (
      // ===== Show Allocation View =====
      <div className="col-md-12">
        {/* Top Section: Selected Item Details 
        <div className="d-flex justify-content-between align-items-center">
          <h5>Item Name:<b> {selectedAllocationItem.dieName}</b></h5>
          <Button type="primary" onClick={() => setSelectedAllocationItem(null)}>
            Back
          </Button>
        </div>

        <Table
          dataSource={[selectedAllocationItem]}
          columns={[
            
             {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Item Entry Date",
      dataIndex: "itemEntryDate",
      key: "itemEntryDate",
      render: (date) => {
        if (!date) return "-";
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      },
    },
    {
      title: "Item Name",
      dataIndex: "dieName",
      key: "dieName",
    },
    // {
    //   title: "Item Details",
    //   key: "alloyTemper",
    //   render: (_, record) => (
    //     <div>
    //       <div><strong>Alloy:</strong> {record.alloyname}</div>
    //       <div><strong>Temper:</strong> {record.temperName}</div>
    //       <div><strong>Length:</strong> {record.length}</div>
    //       <div><strong>Weight:</strong> {record.weight}</div>
    //       <div><strong>Pcs:</strong> {record.pcs}</div>
    //       <div><strong>Quantity:</strong> {record.qty}</div>
    //     </div>
    //   ),
    // },
   
    {
      title: "Alloy",
      dataIndex: "alloyname",
      key: "alloyname",
    },
    {
      title: "Temp",
      dataIndex: "temperName",
      key: "temperName",
    },
    {
      title: "Wt/R",
      dataIndex: "weight",
      key: "weight",
    },
    {
      title: "Length",
      dataIndex: "length",
      key: "length",
    },
    {
      title: "Pcs",
      dataIndex: "pcs",
      key: "pcs",
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
    },
   
    {
      title: "Prod. Status",
      dataIndex: "sendToProduction",
      key: "sendToProduction",
    },
    {
      title: "Allocated Pcs",
      dataIndex: "allocatedPcs",
      key: "allocatedPcs",
    },
    {
      title: "Allocated Qty",
      dataIndex: "allocatedQty",
      key: "allocatedQty",
    },
    {
      title: "Prod. Pcs",
      dataIndex: "productionPcs",
      key: "productionPcs",
    },
    {
      title: "Prod. Qty",
      dataIndex: "productionQty",
      key: "productionQty",
    },

            // Add more item detail columns here
          ]}
          components={components1}
          pagination={false}
          bordered
          rowKey={(record) => record.id}
          scroll={{ x: true }}
        />

        {/* Bottom Section: Stock Tables 
        <div className="row mt-4">
          {/* Available Stock 
          <div className="col-md-6">
            <h6>Available Stock</h6>
            <Table
              dataSource={stockData.filter(
                (stock) => stock.dieName === selectedAllocationItem?.dieName
              )}
              columns={stockColumns}
              pagination={false}
              components={components}
              bordered
              rowKey={(record) => record.stockId}
              scroll={{ x: true }}
            />
          </div>

          {/* Allocated Stock 
          <div className="col-md-6">
            <h6>Allocated Stock</h6>
            <Table
              dataSource={allocatedStock.filter(
                (item) => item.orderItemId === selectedAllocationItem?.id
              )}
              columns={allocatedColumns}
              components={components}
              pagination={false}
              bordered
              rowKey={(record) => record.id}
              scroll={{ x: true }}
            />
          </div>
        </div>
      </div>
    )}
  </div>

  {/* Send to Production Button 
  {selectedItemIds.length > 1 && !selectedAllocationItem && (
    <div className="text-center px-md-5 mb-3">
      <Button
        type="primary"
        onClick={() => handleProduction(selectedItemIds)}
        style={{ marginTop: "10px" }}
      >
        Send to Production
      </Button>
    </div>
  )}
</div> */}

                <div className="mt-4">
                  <div className="row">
                    {!detailView && !selectedAllocationItem ? (
                      // ===== Show Full Order Items Table =====
                      <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center">
                          <h5><strong>Order Items</strong></h5>
                          <Button
                            type="primary"
                            style={{ fontSize: '15px' , marginBottom :"2%" }}
                            onClick={() => {
                              fetchAllocatedBumdles()
                            }}
                          >
                            Detail View
                          </Button>
                        </div>
                          <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
                        <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                                         <div>
                                           <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                                           <Select
                                             defaultValue={pageSize}
                                             onChange={handlePageSizeChange}
                                             style={{ width: 120, textAlign: "center" }}
                                           >
                                             <Option value={10}>10</Option>
                                             <Option value={20}>20</Option>
                                             <Option value={30}>30</Option>
                                           </Select>
                                            
                                         </div>
                                 
                                         <div className="pt-4 pt-md-0">
                                           <Input.Search
                                             placeholder="Search"
                                              onChange={(e) => handleSearch(e.target.value)}
                                             style={{ width: 200, marginBottom: 16 }}
                                           />
                                         </div>
                                       </div>
                        <Table
                          style={{ padding: "0px 20px", overflowX: "auto" }}
                          // dataSource={orderItems}
                          dataSource={filteredData}
                          columns={orderItemColumns}
                          pagination={{
                       pageSize: pageSize,
                       total: totalEntries,
                       showTotal: (total, range) =>
                         `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                       current: currentPage,
                       onChange: (page) => setCurrentPage(page),
                     }}
                          bordered
                          rowKey={(record) => record.id}
                          components={components}
                          scroll={{ x: true }}
                              summary={(pageData) => {
                                                          let totalQty = 0;
                                                          let totalPcs = 0;
                          
                                                          pageData.forEach(({ qty, pcs }) => {
                                                            totalQty += Number(qty) || 0;
                                                            totalPcs += Number(pcs) || 0;
                                                          });
                          
                                                          return (
                                                            <Table.Summary.Row style={{ backgroundColor: "#e1ecf4", }}>
                                                              <Table.Summary.Cell index={0} colSpan={6} />
                                                             <Table.Summary.Cell index={6}><strong>Total:</strong></Table.Summary.Cell>
                                                              {/* <Table.Summary.Cell index={6}  colSpan={2}>Total Pcs: <span style={{fontWeight: "bold"}}>{totalPcs}</span></Table.Summary.Cell>
                                                              <Table.Summary.Cell index={8} >Total Qty: <span style={{fontWeight: "bold"}}>{totalQty}</span></Table.Summary.Cell> */}
                                                                <Table.Summary.Cell index={7}  > <span style={{fontWeight: "bold"}}>{totalPcs}</span></Table.Summary.Cell>
                                                              <Table.Summary.Cell index={8} > <span style={{fontWeight: "bold"}}>{totalQty}</span></Table.Summary.Cell>
                                                              <Table.Summary.Cell index={9} />
                                                              <Table.Summary.Cell index={11} />
                                                              <Table.Summary.Cell index={12} />
                                                               <Table.Summary.Cell index={13} />
                                                                 <Table.Summary.Cell index={14} />
                                                                   <Table.Summary.Cell index={15} />
                                                               <Table.Summary.Cell index={16} />
                                                                       <Table.Summary.Cell index={17} />
                                                                <Table.Summary.Cell index={18} />
                                                            </Table.Summary.Row>
                                                          );
                                                        }}
                          
                        />
                        </div>
                      </div>
                    ) : (
                      !detailView && (
                        // ===== Allocation View (With Stock + Allocated) =====
                        <div className="col-md-12">
                          {/* Top Section: Selected Item Details */}
                          <div className="d-flex justify-content-between align-items-center">
                            <h5>
                              Item Name: <b>{selectedAllocationItem.dieName}</b>
                            </h5>
                            <Button
                              type="primary"
                                                          style={{ fontSize: '15px' , marginBottom :"2%" }}

                              onClick={() => {
                                setSelectedAllocationItem(null)
                                setAllocateBack(false)
                                setDetailView(false)
                              }}
                            >
                              Back
                            </Button>
                          </div>

                          {/* Selected Item Table */}
                          <Table
                            dataSource={[selectedAllocationItem]}
                            columns={[
                              {
                                title: 'Sr.No.',
                                dataIndex: '',
                                key: 'index',
                                render: (text, record, index) => index + 1,
                              },
                              {
                                title: 'Item Entry Date',
                                dataIndex: 'itemEntryDate',
                                key: 'itemEntryDate',
                                render: (date) => {
                                  if (!date) return '-'
                                  const [year, month, day] = date.split('-')
                                  return `${day}/${month}/${year}`
                                },
                              },
                              {
                                title: 'Item Name',
                                dataIndex: 'dieName',
                                key: 'dieName',
                              },
                              {
                                title: 'Alloy',
                                dataIndex: 'alloyname',
                                key: 'alloyname',
                              },
                              {
                                title: 'Temp',
                                dataIndex: 'temperName',
                                key: 'temperName',
                              },
                              {
                                title: 'Wt/R',
                                dataIndex: 'weight',
                                key: 'weight',
                              },
//                              
 {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },


                              { title: 'Pcs', dataIndex: 'pcs', key: 'pcs' },
                              { title: 'Qty', dataIndex: 'qty', key: 'qty' },
                                    {
      title: 'Pend.  Pcs',
      dataIndex: 'pendingOrderPcs',
      key: 'pendingOrderPcs',
    },
    {
      title: 'Pend. Qty',
      dataIndex: 'pendingOrderQty',
      key: 'pendingOrderQty',
    },
                            
                              {
                                title: 'Allo. Pcs',
                                dataIndex: 'allocatedPcs',
                                key: 'allocatedPcs',
                              },
                              {
                                title: 'Allo. Qty',
                                dataIndex: 'allocatedQty',
                                key: 'allocatedQty',
                              },
                              {
                                title: 'Prod. Pcs',
                                dataIndex: 'productionPcs',
                                key: 'productionPcs',
                              },
                              {
                                title: 'Prod. Qty',
                                dataIndex: 'productionQty',
                                key: 'productionQty',
                              },
                                {
                                title: 'Prod. Status',
                                dataIndex: 'sendToProduction',
                                key: 'sendToProduction',
                              },
                          
                            ]}
                            components={components1}
                            pagination={false}
                            bordered
                            rowKey={(record) => record.id}
                            scroll={{ x: true }}
                            
                          />

                          {/* Stock + Allocated Stock Tables */}
                          <div className="row mt-4">
                            <div className="col-md-12">
                              <h6>Available Stock</h6>
                              <Table
                                // dataSource={stockData.filter(
                                //   (stock) => stock.dieName === selectedAllocationItem?.dieName
                                // )}
                                dataSource={stockData}
                                columns={stockColumns}
                                pagination={false}
                                components={components}
                                bordered
                                rowKey={(record) => record.packingId}
                                scroll={{ x: true }}
                              />
                                <div className="d-flex justify-content-center mt-3">
                            <Button
                              type="primary"
                              className="UpdateBtn"
                              style={{color:"white"}}
  onClick={() => handleAllocation(selectedItemIds1)}
>
  Allocate
</Button>
</div>
                            </div>
                            <div className="col-md-12">
                              <h6>Allocated Stock</h6>
                              <Table
                                // dataSource={allocatedStock.filter(
                                //   (item) => item.orderItemId === selectedAllocationItem?.id
                                // )}
                                dataSource={allocatedStock}
                                columns={allocatedColumns}
                                components={components}
                                pagination={false}
                                bordered
                                rowKey={(record) => record.id}
                                scroll={{ x: true }}
                              />
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>

                  {/* Send to Production Button */}
                  {selectedItemIds.length > 1 && !selectedAllocationItem && !detailView && (
                    <div className="text-center px-md-5 mb-3">
                      <Button
        type="primary"
        onClick={() => handleProduction(selectedItemIds)}
        style={{ marginTop: "10px" }}
      >
        Send to Production
      </Button>
                      {/* <Button
  type="primary"
  onClick={() => showConfirmationModal(selectedItemIds)} // pass multiple IDs
  style={{ marginTop: "10px" }}
>
  Send to Production
</Button> */}

                    </div>
                  )}
                </div>

                {detailView && (
                  <div className="col-md-12">
                    {/* Show Back button only once */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div></div>
                      <Button
                        type="primary"
style={{ fontSize: '15px' , marginBottom :"2%" }}

                        onClick={() => {
                          setSelectedAllocationItem(null)
                          setAllocateBack(false)
                          setDetailView(false)
                        }}
                      >
                        Back
                      </Button>
                    </div>

                    {/* Now map over orderItems */}
                    {orderItems.map((orderItem, index) => {
                      const dieName = orderItem.dieName?.trim()
                      const allocatedItems = groupedDataByDieName[dieName] || []
                       {/* const dieName = orderItem.dieName?.trim() || '';
  const alloy = orderItem.alloyname?.trim() || '';
  const temper = orderItem.temperName?.trim() || '';

  const key = `${dieName}|${alloy}|${temper}`;
  const allocatedItems = groupedDataByDieName[key] || []; */}

                      return (
                        <div key={`${dieName}_${index}`} className="mb-4">
                          <h6 className="text-center mb-3">
                            Allocated Stock for: {dieName}
                          </h6>

                          <Table
                            dataSource={[orderItem]}
                               columns={[
                              {
                                title: 'Sr.No.',
                                dataIndex: '',
                                key: 'index',
                                render: (text, record, index) => index + 1,
                              },
                              {
                                title: 'Item Entry Date',
                                dataIndex: 'itemEntryDate',
                                key: 'itemEntryDate',
                                render: (date) => {
                                  if (!date) return '-'
                                  const [year, month, day] = date.split('-')
                                  return `${day}/${month}/${year}`
                                },
                              },
                              {
                                title: 'Item Name',
                                dataIndex: 'dieName',
                                key: 'dieName',
                              },
                              {
                                title: 'Alloy',
                                dataIndex: 'alloyname',
                                key: 'alloyname',
                              },
                              {
                                title: 'Temp',
                                dataIndex: 'temperName',
                                key: 'temperName',
                              },
                              {
                                title: 'Wt/R',
                                dataIndex: 'weight',
                                key: 'weight',
                              },
//                               {
//                                 title: 'Length',
//                                 dataIndex: 'length',
//                                 key: 'length',
//                               }, 
//                               {
//   title: 'Unit',
//   dataIndex: 'unit',
//   key: 'unit',
//   render: (unit) => {
//     const unitOption = goodTypesOptions.find((opt) => opt.value === String(unit));
//     return unitOption ? unitOption.label : '';
//   },
// }
// ,
 {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },


                              { title: 'Pcs', dataIndex: 'pcs', key: 'pcs' },
                              { title: 'Qty', dataIndex: 'qty', key: 'qty' },
                                    {
      title: 'Pend.  Pcs',
      dataIndex: 'pendingOrderPcs',
      key: 'pendingOrderPcs',
    },
    {
      title: 'Pend. Qty',
      dataIndex: 'pendingOrderQty',
      key: 'pendingOrderQty',
    },
                            
                              {
                                title: 'Allo. Pcs',
                                dataIndex: 'allocatedPcs',
                                key: 'allocatedPcs',
                              },
                              {
                                title: 'Allo. Qty',
                                dataIndex: 'allocatedQty',
                                key: 'allocatedQty',
                              },
                              {
                                title: 'Prod. Pcs',
                                dataIndex: 'productionPcs',
                                key: 'productionPcs',
                              },
                              {
                                title: 'Prod. Qty',
                                dataIndex: 'productionQty',
                                key: 'productionQty',
                              },
                                {
                                title: 'Prod. Status',
                                dataIndex: 'sendToProduction',
                                key: 'sendToProduction',
                              },
                          
                            ]}
                            pagination={false}
                            bordered
                               components={components1}
                            rowKey={(record) =>
                              record.orderNumber + '_' + record.dieName
                            }
                            scroll={{ x: true }}
                          />

                          <Table
                            className="mt-3"
                            dataSource={allocatedItems}
                            columns={allocatedColumns}
                            locale={{ emptyText: 'No allocated stock' }}
                            pagination={false}
                            bordered
                            rowKey={(record) => record.packingId}
                            components={components}
                            scroll={{ x: true }}
                          />
                        </div>
                      )
                    })}
                  </div>
                )}
<Modal
  title="Confirm Production"
  visible={isModalVisible}
  onCancel={() => setIsModalVisible(false)}
  footer={null}
  width={500}
>
  <p>Are you sure you want to send the selected order(s) to production?</p>

  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
    <Button onClick={() => setIsModalVisible(false)}>Cancel</Button>
    <Button
      type="primary"
      onClick={() => {
        handleProduction(pendingProductionIds);
        setIsModalVisible(false);
      }}
    >
      Yes, Send to Production
    </Button>
  </div>
</Modal>

                {!allocateBack && !detailView && (
                  <div className="text-center px-md-5 mb-3">
                    <Button
                      type="submit"
                      className="CancelBtn mx-1"
                       style={{ fontSize: '15px' , marginTop :"2%" }}

                      onClick={() => {
                        fetchOrderAllotmentData()
                        setSelectedOrder(null)
                        setOrderItems([])
                        setApprovedItems(new Set())
                        setSelectedItemIds([])
                           window.close(); 
                   navigate('/sales7',{ state: { refresh: true } }); 
                   
                        setSelectedOrderItem('')
                        setSelectedAllocationItem('')
                        setAllocateBack(false) // ← Add this line
                      }}
                    >
                      Back to Page
                    </Button>
                  </div>
                )}
              
        
          </div>
        </div>
      </div>
    </div>
  )
}


export default OrderAllotmentDetails